<template>
  <!-- <el-scrollbar ref="myScrollbar" wrap-class="main-scrollbar"> -->
  <div id="bar" class="layout" :class="[topScroll?'topScroll':'']">
    <app-header ref="appHeader" :top-scroll="topScroll" />
    <main class="layout-main">
      <div :class="$route.path==='/home' || $route.path==='/mainItem' || $route.path==='/mainDetail' || $route.path==='/searhResult' ? 'layout-home':'layout-contain'">
        <transition name="fade-transform" mode="out-in">
          <router-view />
        </transition>
      </div>
    </main>
    <app-footer />
  </div>
  <!-- </el-scrollbar> -->
</template>

<script>
import AppHeader from './AppHeader.vue';
import AppFooter from './AppFooter.vue';
export default {
  name: 'Layout',
  components: {
    AppHeader,
    AppFooter
  },
  data() {
    return {
      topScroll: false
    };
  },
  watch: {
    $route: {
      handler: function() {
        if (this.$refs.myScrollbar && this.$refs.myScrollbar.wrap) {
          this.$refs.myScrollbar.wrap.scrollTop = 0;
        }
      },
      immediate: true
    }
  },
  mounted() {
    this.$store.dispatch('FetchportalInfo'); // 获取门户信息
    this.$store.dispatch('FetchportalNav'); // 获取导航
    this.$store.dispatch('getadvList');// 获取广告
    window.addEventListener('scroll', this.handleScroll);
  },
  destroyed() {
    window.removeEventListener('scroll', this.handleScroll);
  },
  methods: {
    handleScroll() {
      var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
      var offsetTop = document.getElementById('bar').offsetTop;
      const nav = document.getElementById('header-nav');
      if (scrollTop > offsetTop) {
        this.topScroll = true;
        if (this.$refs.appHeader.sarchShow) this.$util.fadeOut(nav, 30);
      } else {
        this.topScroll = false;
        this.$util.fadeIn(nav, 30);
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.layout {
  display: flex;
  flex-flow: column;
  min-height: 100vh;
  .layout-main {
    flex: 1;
    width: 100%;
    // padding: 20px 0;
    // padding-bottom: 20px;
    background-color: #EFF2F9;
    margin-top: 158px;
    padding-bottom: 20px;
    .layout-home{
       width: 100%;
    }
    .layout-contain {
      // width: 100%;
      // max-width: 80%;
      width: 1200px;
      margin: 30px auto;
      // background-color: #fff;
    }
  }
}
</style>
